import React from "react";
import {useAtom} from "jotai";
import {
    Box,
    Button,
    Stack,
    Typography,
} from "@mui/material";

import {HugeiconsIcon} from "@hugeicons/react";
import Modal from "@mui/material/Modal";
import {grey} from "@mui/material/colors";
import {ConfirmDialogAtom} from "../../pages/project/atoms";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: "440px", width: "90%",
    maxHeight: "50dvh",
    bgcolor: 'background.paper',
    borderRadius: 2,
    border: '0px solid #000',
    boxShadow: 24,
    p: 3,
    overflowY: "auto"
};


export const ConfirmDialogModal = () => {
    const [dialog, setDialog] = useAtom(ConfirmDialogAtom);

    const handleClose = () => {
        setDialog((prev) => ({...prev, open: false}));
    };

    const handleConfirm = () => {
        dialog.resolve(true); // Resolve the promise with true
        handleClose();
    };

    const handleCancel = () => {
        dialog.resolve(false); // Resolve the promise with false
        handleClose();
    };

    return (
        <Modal
            open={dialog.open} onClose={handleCancel}
        >
            <Stack direction={"column"} gap={2} sx={style}>
                <Typography fontWeight={600} fontSize={"1.15rem"}>{dialog.title}</Typography>
                <Box>
                    <Typography fontWeight={600} fontSize={"0.95rem"} color={grey[600]}>{dialog.message}</Typography>
                </Box>
                <Stack direction={"row"} gap={2} justifyContent={dialog.icon ? "space-between" : "flex-end"}>
                    <Button onClick={handleCancel} color="secondary" variant="ghost">
                        {dialog?.cancelText || "Cancel"}
                    </Button>
                    {dialog.icon ? (
                        <Button
                            onClick={handleConfirm}
                            startIcon={<HugeiconsIcon icon={dialog.icon} size={16}/>}
                            sx={{
                                borderRadius: "10px", textTransform: "none", fontWeight: 600, color: "#4B55C9",
                                bgcolor: "rgba(132, 145, 247, 0.14)", "&:hover": {bgcolor: "rgba(132, 145, 247, 0.24)"}
                            }}
                        >
                            {dialog?.confirmText || "Confirm"}
                        </Button>
                    ) : (
                        <Button sx={{borderRadius: 2}} onClick={handleConfirm} color="secondary" variant="modal">
                            {dialog?.confirmText || "Confirm"}
                        </Button>
                    )}
                </Stack>
            </Stack>
        </Modal>
    );
};
